import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import API from '../../utils/api';
import { Link } from 'react-router-dom';

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  const [banners, setBanners] = useState([]);
  const [subs, setSubs] = useState([]);

  useEffect(() => {
    API.get('/admin/stats').then(r => setStats(r.data));
    API.get('/admin/banners').then(r => setBanners(r.data));
    API.get('/admin/subscriptions').then(r => setSubs(r.data.filter(s => s.status === 'pending')));
  }, []);

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '32px 20px' }}>
        <div className="page-header">
          <h1>🛡️ Admin Dashboard</h1>
          <p>Platform overview and management</p>
        </div>

        <div className="grid-4" style={{ marginBottom: 28 }}>
          {[
            { label: 'Total Users', value: stats.totalUsers || 0, icon: '👥' },
            { label: 'Total Exams', value: stats.totalExams || 0, icon: '📝' },
            { label: 'Total Attempts', value: stats.totalAttempts || 0, icon: '✍️' },
            { label: 'Pending Approvals', value: stats.pendingSubs || 0, icon: '⏳', alert: true },
          ].map(s => (
            <div key={s.label} className="card stat-card" style={{ borderColor: s.alert && s.value > 0 ? 'var(--warning)' : undefined }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>{s.icon}</div>
              <div className="stat-value" style={{ color: s.alert && s.value > 0 ? 'var(--warning)' : undefined }}>{s.value}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="grid-2">
          <div className="card">
            <div className="flex-between mb-4">
              <h3 style={{ fontWeight: 700 }}>⏳ Pending Subscriptions</h3>
              <Link to="/admin/subscriptions" className="btn btn-secondary btn-sm">View All</Link>
            </div>
            {subs.length === 0 ? <p className="text-muted text-sm">No pending approvals</p> : subs.slice(0,5).map(s => (
              <div key={s.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{s.full_name}</div>
                  <div style={{ fontSize: 12, color: 'var(--text2)' }}>{s.plan_name} • {s.phone}</div>
                </div>
                <Link to="/admin/subscriptions" className="badge badge-warning">Review</Link>
              </div>
            ))}
          </div>

          <div className="card">
            <div className="flex-between mb-4">
              <h3 style={{ fontWeight: 700 }}>🚀 Quick Actions</h3>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Link to="/admin/users" className="btn btn-secondary">👥 Manage Users</Link>
              <Link to="/admin/plans" className="btn btn-secondary">📦 Manage Plans</Link>
              <Link to="/admin/subscriptions" className="btn btn-secondary">💳 Review Subscriptions</Link>
              <Link to="/admin/settings" className="btn btn-secondary">⚙️ Platform Settings</Link>
            </div>
          </div>
        </div>

        {banners.length > 0 && (
          <div className="card" style={{ marginTop: 24 }}>
            <h3 style={{ fontWeight: 700, marginBottom: 16 }}>📢 Active Banners</h3>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {banners.map(b => (
                <img key={b.id} src={b.image_path} alt="banner" style={{ height: 80, borderRadius: 8, objectFit: 'cover' }} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
